import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import Index from "./pages/Index";
import PackageDetail from "./pages/PackageDetail";
import UmrahPackages from "./pages/UmrahPackages";
import HajjPackages from "./pages/HajjPackages";
import AboutUs from "./pages/AboutUs";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import CategoryDetail from "./pages/CategoryDetail";
import ManasikUmrah from "./pages/categories/ManasikUmrah";
import PerlengkapanIbadah from "./pages/categories/PerlengkapanIbadah";
import EGuideMateri from "./pages/categories/EGuideMateri";
import AktivitasJamaah from "./pages/categories/AktivitasJamaah";



// Auth Pages
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";

// Admin Pages
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminHomepage from "./pages/admin/AdminHomepage";
import AdminUmrahPackages from "./pages/admin/AdminUmrahPackages";
import AdminHajjPackages from "./pages/admin/AdminHajjPackages";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminServiceIcons from "./pages/admin/AdminServiceIcons";
import AdminPrayerTimes from "./pages/admin/AdminPrayerTimes";
import AdminHighlights from "./pages/admin/AdminHighlights";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminAbout from "./pages/admin/AdminAbout";
import AdminArrangementSection from "./pages/admin/AdminArrangementSection";
import AdminExploreSection from "./pages/admin/AdminExploreSection";
import AdminManasikUmrah from "./pages/admin/AdminManasikUmrah";
import AdminPerlengkapanIbadah from "./pages/admin/AdminPerlengkapanIbadah";
import AdminEGuideMateri from "./pages/admin/AdminEGuideMateri";
import AdminAktivitasJamaah from "./pages/admin/AdminAktivitasJamaah";
import AdminFooter from "./pages/admin/AdminFooter";
import AdminNavigation from "./pages/admin/AdminNavigation";
import AdminUsers from "./pages/admin/AdminUsers";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
<BrowserRouter>
  <Routes>
    <Route path="/" element={<Index />} />

    {/* Public Pages */}
    <Route path="/umrah-packages" element={<UmrahPackages />} />
    <Route path="/hajj-packages" element={<HajjPackages />} />
    <Route path="/about-us" element={<AboutUs />} />
    <Route path="/gallery" element={<Gallery />} />
    <Route path="/blog" element={<Blog />} />
    <Route path="/contact" element={<Contact />} />
    <Route path="/package/:id" element={<PackageDetail />} />

    {/* 🔥 CATEGORY DETAIL */}
    <Route path="/kategori/manasik-umrah" element={<ManasikUmrah />} />
    <Route path="/kategori/perlengkapan-ibadah" element={<PerlengkapanIbadah />} />
    <Route path="/kategori/e-guide-materi" element={<EGuideMateri />} />
    <Route path="/kategori/aktivitas-jamaah" element={<AktivitasJamaah />} />
    <Route path="/kategori/:slug" element={<CategoryDetail />} />

    {/* Auth */}
    <Route path="/login" element={<Login />} />
    <Route path="/register" element={<Register />} />

    {/* Admin */}
    <Route path="/admin" element={<AdminLogin />} />
    <Route path="/admin/dashboard" element={<AdminDashboard />} />
    <Route path="/admin/homepage" element={<AdminHomepage />} />
    <Route path="/admin/arrangement" element={<AdminArrangementSection />} />
    <Route path="/admin/umrah-packages" element={<AdminUmrahPackages />} />
    <Route path="/admin/hajj-packages" element={<AdminHajjPackages />} />
    <Route path="/admin/blog" element={<AdminBlog />} />
    <Route path="/admin/gallery" element={<AdminGallery />} />
    <Route path="/admin/messages" element={<AdminMessages />} />
    <Route path="/admin/service-icons" element={<AdminServiceIcons />} />
    <Route path="/admin/prayer-times" element={<AdminPrayerTimes />} />
    <Route path="/admin/explore" element={<AdminExploreSection />} />
    <Route path="/admin/highlights" element={<AdminHighlights />} />
    <Route path="/admin/products" element={<AdminProducts />} />
    <Route path="/admin/about" element={<AdminAbout />} />
    <Route path="/admin/settings" element={<AdminSettings />} />
    <Route path="/admin/manasik-umrah" element={<AdminManasikUmrah />} />
    <Route path="/admin/perlengkapan-ibadah" element={<AdminPerlengkapanIbadah />} />
    <Route path="/admin/e-guide-materi" element={<AdminEGuideMateri />} />
    <Route path="/admin/aktivitas-jamaah" element={<AdminAktivitasJamaah />} />
    <Route path="/admin/footer" element={<AdminFooter />} />
    <Route path="/admin/navigation" element={<AdminNavigation />} />
    <Route path="/admin/users" element={<AdminUsers />} />

    {/* Catch all */}
    <Route path="*" element={<NotFound />} />
  </Routes>
</BrowserRouter>

      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
